import React from "react";
import { Box, Typography, Paper } from "@mui/material";

/**
 * A reusable empty state component to display when content is not available
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.icon - Icon to display
 * @param {string} props.title - Title text
 * @param {string} props.description - Description text
 * @param {React.ReactNode} props.action - Optional action button
 * @returns {JSX.Element}
 */
const EmptyState = ({ icon, title, description, action }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        borderRadius: 2,
        bgcolor: "background.paper",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        mb: 3,
      }}
    >
      {icon && <Box sx={{ color: "text.secondary", mb: 2 }}>{icon}</Box>}

      {title && (
        <Typography variant="h6" color="text.primary" gutterBottom>
          {title}
        </Typography>
      )}

      {description && (
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ maxWidth: 600, mx: "auto", mb: action ? 3 : 0 }}
        >
          {description}
        </Typography>
      )}

      {action && action}
    </Paper>
  );
};

export default EmptyState;
